import { lazy } from "react";

export const MedicalCardAsync = lazy(() => import("./MedicalCard"));
